import { Injectable } from "@angular/core";
import { Store, Action, select } from "@ngrx/store";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Observable } from "rxjs";
import { withLatestFrom, map, switchMap, filter } from "rxjs/operators";

import * as fromCore from "../reducers/index";
import * as fromCountryParametersAction from "../actions/country-parameters.action";

import { ParametersService } from "../services/parameters.service";

@Injectable()
export class CountryParammetersEffect {
  constructor(
    private actions$: Actions,
    private store$: Store<fromCore.State>,
    private parameters$: ParametersService
  ) {}

  fetchCountryParameters$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromCountryParametersAction.FetchCountryParameters>(
        fromCountryParametersAction.ActionTypes.FETCH_COUNTRY_PARAMETERS
      ),
      withLatestFrom(
        this.store$.pipe(
          select(fromCore.getLegalEntity),
          filter((legalEntity) => legalEntity !== undefined)
        )
      ),
      switchMap(([action, legalEntity]) => {
        return this.parameters$.getCountryParameters(legalEntity.countryCode).pipe(
          map((parameters) => {
            return new fromCountryParametersAction.FetchCountryParametersSuccess(parameters);
          })
        );
      })
    )
  );
}
